module.exports = {"Arox":"Arox WMS","ExactGlobe":"Exact Globe","Unit4":"Unit4"}